/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListVersionsSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListVersionsSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListVersionsSecurity = {
  option1?: ListVersionsSecurityOption1 | undefined;
  option2?: ListVersionsSecurityOption2 | undefined;
};

export type ListVersionsRequest = {
  /**
   * The name of the package
   */
  name: string;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListVersionsSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListVersionsSecurityOption1$outboundSchema: z.ZodMiniType<
  ListVersionsSecurityOption1$Outbound,
  ListVersionsSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listVersionsSecurityOption1ToJSON(
  listVersionsSecurityOption1: ListVersionsSecurityOption1,
): string {
  return JSON.stringify(
    ListVersionsSecurityOption1$outboundSchema.parse(
      listVersionsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListVersionsSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListVersionsSecurityOption2$outboundSchema: z.ZodMiniType<
  ListVersionsSecurityOption2$Outbound,
  ListVersionsSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listVersionsSecurityOption2ToJSON(
  listVersionsSecurityOption2: ListVersionsSecurityOption2,
): string {
  return JSON.stringify(
    ListVersionsSecurityOption2$outboundSchema.parse(
      listVersionsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListVersionsSecurity$Outbound = {
  Option1?: ListVersionsSecurityOption1$Outbound | undefined;
  Option2?: ListVersionsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListVersionsSecurity$outboundSchema: z.ZodMiniType<
  ListVersionsSecurity$Outbound,
  ListVersionsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListVersionsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListVersionsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listVersionsSecurityToJSON(
  listVersionsSecurity: ListVersionsSecurity,
): string {
  return JSON.stringify(
    ListVersionsSecurity$outboundSchema.parse(listVersionsSecurity),
  );
}

/** @internal */
export type ListVersionsRequest$Outbound = {
  name: string;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListVersionsRequest$outboundSchema: z.ZodMiniType<
  ListVersionsRequest$Outbound,
  ListVersionsRequest
> = z.pipe(
  z.object({
    name: z.string(),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listVersionsRequestToJSON(
  listVersionsRequest: ListVersionsRequest,
): string {
  return JSON.stringify(
    ListVersionsRequest$outboundSchema.parse(listVersionsRequest),
  );
}
